import styled from "styled-components";

export const FooterWrap = styled.div`
    display: flex;
    height: 25px;
    background-color: black;
    padding: 10px;
    color: white;
    margin-top: 70px;
    
`;
